import { render, staticRenderFns } from "./VatRates.vue?vue&type=template&id=4e7e793c&scoped=true"
import script from "./VatRates.vue?vue&type=script&lang=ts"
export * from "./VatRates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7e793c",
  null
  
)

export default component.exports